export default "__VITE_ASSET__Dp7LG_kK__"